import {Component} from "@angular/core";
import {AuthenticationService} from "../authentication.service";

@Component({
    selector: "app-alert",
    templateUrl: "./alert.component.html"
})
export class AlertComponent {
  constructor(public authenticationService: AuthenticationService) {}

  dismissAlert() {
    this.authenticationService.showAlert = false;
  }
}
